<template>
  <v-card class="pa-0 ma-1 justify-center" fluid flat>
    <v-row>
      <v-checkbox
        dense
        hide-details
        v-if="!field.data.required"
        v-model="selected"
        :label="NO_ITEM.text"
        :value="NO_ITEM"
        @change="changed"
        class="checkbox"
      ></v-checkbox>
    </v-row>
    <v-row>
      <v-flex class="my-2" v-for="item in options" :key="item.text" xs12 sm6 md4 lg3 xl2>
        <v-card class="mx-2" height="100%">
          <v-img
            height="78%"
            :src="getImgFromBuffer(images[item.imgId])"
            class="white--text"
            aspect-ratio="1"
            contain
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          >
            <v-card-title class="fill-height align-end" v-text="item.text"></v-card-title>
          </v-img>

          <v-card-actions fill-height class="pa-0 ma-0 align-center">
            <v-container class="pa-0 ma-0 align-center">
              <v-row justify="center">
                <v-checkbox
                  hide-details
                  v-model="selected"
                  :label="`${item.text}${item.hasPrice ? ' ($' + item.price + ')' : ''}`"
                  :value="item"
                  @change="changed"
                  class="mt-2 pa-0 shrink"
                  height="25px"
                ></v-checkbox>
              </v-row>
              <v-row justify="center" class="ma-0 pa-0">
                <v-btn
                  icon
                  @click="subCount(item)"
                  v-if="field.data.countable && selected.includes(item)"
                  class="ma-0 pa-1"
                >
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="ma-0 pa-0"
                  v-if="field.data.countable && selected.includes(item)"
                  >{{ item.count }}</v-btn
                >

                <v-btn
                  icon
                  class="ma-0 pa-0"
                  @click="addCount(item)"
                  v-if="field.data.countable && selected.includes(item)"
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-row>
            </v-container>
            <!-- <v-card   class="align-center col-12" flat>
                <v-card flat>
                  <v-checkbox
                    v-model="selected"
                    :label="`${item.text}${item.hasPrice?'($'+item.price+')':''}`"
                    :value="item"
                    @change="changed"
                  ></v-checkbox>
                </v-card>
                <v-card flat>
              <v-btn
                icon
                @click="subCount(item)"
                v-if="field.data.countable && selected.includes(item)"
              >
                <v-icon> mdi-minus-circle-outline</v-icon>
              </v-btn>

              <v-btn icon v-if="field.data.countable && selected.includes(item)">{{item.count}}</v-btn>

              <v-btn
                icon
                @click="addCount(item)"
                v-if="field.data.countable && selected.includes(item)"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
                </v-card>
            </v-card>-->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NO_ITEM from '@/constants/noItem'
export default {
  name: 'ProductsCards',
  data() {
    return {
      valid: false,
      selected: [],
      options: [],
      NO_ITEM
    }
  },
  created() {
    this.options = [...this.field.data.attrs.options]
    if (this.field.data.countable) {
      this.options.forEach(item => {
        if (!item.count) item.count = 1
      })
    }
    if (this.defaultValue) {
      ;(this.selected = this.defaultValue), this.loadOriginalImages(this.field)
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: Array
    }
  },
  computed: {
    images() {
      return this.allImages()
    }
  },
  methods: {
    ...mapActions('images', ['loadOriginalImages']),
    ...mapGetters('images', ['allImages']),
    addCount(item) {
      item.count++
      this.selected = [...this.selected]
      this.changed()
    },
    subCount(item) {
      if (item.count > 1) item.count--
      this.selected = [...this.selected]
      this.changed()
    },
    getImgFromBuffer(buffer) {
      try {
        return 'data:image/jpg;base64, ' + buffer.toString('base64')
      } catch {
        return 'img/no_image.png'
      }
    },
    getCardTitle(item) {
      return `${item.text} ${item.hasPrice ? ` ($ ${item.price})` : ''}`
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => (value && value.length > 0) || 'Required.')
      }
      return rulesF
    },
    getValueObj(item) {
      const obj = { text: item.text }
      if (item.hasPrice) obj.price = item.price
      if (this.field.data.countable) obj.count = item.count
      return obj
    },
    changed() {
      if (!this.field.required && this.selected.length > 1) {
        if (this.selected[this.selected.length - 1] == this.NO_ITEM) {
          this.selected.splice(0, this.selected.length - 1)
        } else if (this.selected[0] == this.NO_ITEM) this.selected.splice(0, 1)
      }
      this.onChange({
        id: this.field._id,
        value: this.selected.map(item => this.getValueObj(item)),
        rawValues: this.selected,
        ...this.getValidationResults()
      })
    },
    getValidationResults() {
      return this.selected.length > 0
        ? { errMsg: null, valid: true }
        : { errMsg: 'Required', valid: false }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__actions {
  height: 20%;
}
</style>
